"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupFactories = void 0;
var ramda_1 = require("ramda");
var Box_1 = require("./factories/layouts/Box");
var factory_utils_1 = require("./internal/factory-utils");
// NOTE: Too slow, causes typescript to crash due to huge types being generated.
// type ObjectPaths<T extends object> = T extends readonly unknown[]
//   ? never
//   :
//       | (keyof T & string)
//       | {
//           [K in keyof T]: T[K] extends object ? `${K & string}.${ObjectPaths<T[K]>}` : K & string
//         }[keyof T]
// type PropType<T, Path extends string> = string extends Path
//   ? unknown
//   : Path extends keyof T
//   ? T[Path]
//   : Path extends `${infer K}.${infer R}`
//   ? K extends keyof T
//     ? PropType<T[K], R>
//     : unknown
//   : unknown
// const makeGlobal = <Global extends object>(global: Global) => {
//   return {
//     global<Path extends ObjectPaths<Global>>(path: Path): PropType<Global, Path> {
//       return path.split('.').reduce((obj, key) => {
//         if (typeof obj === 'object' && obj !== null) {
//           return (obj as any)[key]
//         }
//         return undefined
//       }, global as any)
//     }
//   }
// }
var setupFactories = function (factories, breakpoints) {
    if (breakpoints === void 0) { breakpoints = factory_utils_1.DEFAULT_BREAKPOINTS; }
    var utils = factory_utils_1.createFactoryUtils(breakpoints);
    var Main = Box_1.FactoryBox('Main', { tagName: 'main', flexGrow: 1 }, utils);
    var Page = Box_1.FactoryBox('Page', { height: '100vh', flexDirection: 'column' }, utils);
    return Object.entries(factories).reduce(function (acc, _a) {
        var _b;
        var _c = __read(_a, 2), alias = _c[0], componentFactory = _c[1];
        return __assign(__assign({}, acc), (_b = {}, _b["create" + alias + "Components"] = function (defaultSettings, variants) {
            var _a;
            if (variants === void 0) { variants = {}; }
            var components = (_a = {}, _a[alias] = componentFactory(alias, defaultSettings, utils), _a);
            return __assign({}, Object.entries(variants !== null && variants !== void 0 ? variants : {}).reduce(function (accVariants, _a) {
                var _b;
                var _c = __read(_a, 2), variantName = _c[0], variantSettings = _c[1];
                var settings = ramda_1.mergeDeepRight(defaultSettings, variantSettings);
                var displayName = "" + alias + variantName;
                return __assign(__assign({}, accVariants), (_b = {}, _b[displayName] = componentFactory(displayName, settings, utils), _b));
            }, components));
        }, _b["create" + alias + "VariantComponents"] = function (variants) {
            if (variants === void 0) { variants = {}; }
            return __assign({}, Object.entries(variants !== null && variants !== void 0 ? variants : {}).reduce(function (accVariants, _a) {
                var _b;
                var _c = __read(_a, 2), variantName = _c[0], variantSettings = _c[1];
                var displayName = "" + alias + variantName;
                return __assign(__assign({}, accVariants), (_b = {}, _b[displayName] = componentFactory(displayName, variantSettings, utils), _b));
            }, {}));
        }, _b));
    }, { utils: utils, BREAKPOINTS: breakpoints, Main: Main, Page: Page });
};
exports.setupFactories = setupFactories;
